var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('card-header',{attrs:{"title":_vm.title,"icon":_vm.icon,"color":"primary","variant":"gradient"}}),_c('v-card-text',[_c('div',[_c('simple-table-content',{attrs:{"data":_vm.data,"columns":_vm.columns}})],1),_vm._t("buttons")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }